import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext, useId } from 'react';
import PDPStickyButtonsContext from './PDPStickyButtonsContext';
const noop = () => {};
const usePdpSetStickyPriceRow = () => {
  const $ = _c(3);
  const id = useId();
  const registerStickyPriceRow = useContext(PDPStickyButtonsContext)?.registerStickyPriceRow;
  let t0;
  if ($[0] !== id || $[1] !== registerStickyPriceRow) {
    t0 = node => {
      (registerStickyPriceRow ?? noop)(id, node);
    };
    $[0] = id;
    $[1] = registerStickyPriceRow;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default usePdpSetStickyPriceRow;